import { apiClient } from "./apiClient";

type RequestBody = Record<string, any>;

export const get = (url: string) => apiClient(url, { method: "GET" });

export const post = (url: string, body?: RequestBody) =>
  apiClient(url, {
    method: "POST",
    body: JSON.stringify(body),
  });

export const put = (url: string, body: RequestBody) =>
  apiClient(url, {
    method: "PUT",
    body: JSON.stringify(body),
  });

export const patch = (url: string, body: RequestBody) =>
  apiClient(url, {
    method: "PATCH",
    body: JSON.stringify(body),
  });

export const upload = (url: string, formData: FormData) =>
  apiClient(url, {
    method: "POST",
    body: formData,
    isFormData: true,
  });
